import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

import SidebarModal from './SidebarModal'
import RadioSelections from './tabs/RadioSelections'
import Button from './Button'

import styles from './RadioSelectionModal.module.scss'

const RadioSelectionModal = ({ className, show, toggleShow, title, selectionTitle, buttonText, items, onDone }) => {
  const classNames = cn(styles.radioSelectionModal, className)
  const [itemSelected, setItemSelected] = useState({})
  let printerListComponent = (
    <RadioSelections
      title={selectionTitle}
      options={items}
      selectedOption={itemSelected}
      onSetOption={setItemSelected}
    />
  )

  if ((items?.length ?? 0) === 0) {
    printerListComponent = (
      <p>No printers found</p>
    )
  }

  return (
    <SidebarModal
      className={classNames}
      onClose={() => toggleShow(false)}
      show={show}
      title={title}
    >
      <div className={styles.bodyContainer}>
        {printerListComponent}
        <div className={styles.buttonContainer}>
          {!isEmpty(itemSelected) && (
            <Button
              className={[styles.actionButton, styles.mintGreenHighlight]}
              onClick={() => {
                onDone(itemSelected)
                toggleShow(false)
              }}>
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </SidebarModal>
  )
}

RadioSelectionModal.defaultProps = {
  show: false,
  toggleShow: () => {},
  title: 'Make Selection',
  selectionTitle: 'Select item',
  buttonText: 'Done',
  items: [],
  onDone: () => {},
}

RadioSelectionModal.propTypes = {
  show: PropTypes.bool,
  toggleShow: PropTypes.func,
  title: PropTypes.string,
  selectionTitle: PropTypes.string,
  buttonText: PropTypes.string,
  onDone: PropTypes.func,
}

export default RadioSelectionModal
